import React from "react";
import { Link } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as CoreLogo } from "./core.svg";
import { MANAGE_MAPPER_ROUTES } from "../../../utils";
import {
  faBracketsCurly,
  faFileSpreadsheet,
} from "@fortawesome/pro-light-svg-icons";
import AddToolTip from "../../../components/AddToolTip";

const coreIconSource = "./core.ico";

const inputCategories = ["-", "Census", "Payroll", "Census & Payroll"];
const outputCategories = ["-", "Payroll", "Census", "Census & Payroll"];

function ProfilesTile({
  mapperProfileName = "Mapper Profile Name",
  // description = "Description goes here",
  sourceType = "File",
  targetType = "CORE",
  category = "Census And Payroll",
  // level = "Global",
  profileType = "Input Map",
  associatedPlans,
  isActive = true,
  profileId,
  mapType,
}) {
  return (
    <Link
      to={`${MANAGE_MAPPER_ROUTES.OVERVIEW}/edit/${mapType}/${profileId}`}
      className="border rounded mr-3 p-3 mb-3 text-decoration-tile"
      style={{ display: "flex", marginTop: "5px", width: "100%" }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "start",
          gap: "10px",
          flexWrap: "nowrap",
          color: "black",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "25%", marginRight: "-20px" }}>
          {mapperProfileName?.length > 30 ? (
            <AddToolTip name={mapperProfileName}>
              <div
                className="font-weight-bold mb-1"
                style={{ fontSize: "16px" }}
              >
                {(mapperProfileName || "").slice(0, 30)}...
              </div>
            </AddToolTip>
          ) : (
            <div
              className="font-weight-bold mb-1 mr-auto"
              style={{ fontSize: "16px" }}
            >
              {mapperProfileName}
            </div>
          )}
          {/* {description?.length > 30 ? (
            <AddToolTip name={description}>
              <div style={{ color: "grey", whiteSpace: "nowrap" }}>
                {(description || "").slice(0, 30)}...
              </div>
            </AddToolTip>
          ) : (
            <div style={{ color: "grey", whiteSpace: "nowrap" }}>
              {description}
            </div>
          )} */}
        </div>
        <div style={{ width: "10%" }}>
          <div
            style={{ fontSize: "14px", color: "grey", textDecoration: "none" }}
            className="mb-1"
          >
            Map type
          </div>
          <div>
            {profileType == 1 || profileType == 0
              ? "Input Map"
              : profileType == 2
              ? "Output Map"
              : "Passthrough"}
          </div>
        </div>

        <div>
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Source type
          </div>
          <div className="d-flex">
            <div>
              {sourceType == "CORE" ? (
                <CoreLogo />
              ) : sourceType == "Json" ? (
                <FontAwesomeIcon
                  icon={faBracketsCurly}
                  color="#1C59A5"
                  style={{ fontSize: "18px" }}
                />
              ) : sourceType == "File" ? (
                <FontAwesomeIcon
                  icon={faFileSpreadsheet}
                  color="#219653"
                  style={{ fontSize: "18px" }}
                />
              ) : (
                <></>
              )}
            </div>
            <div className="ml-2" style={{ fontSize: "14px" }}>
              {sourceType}
            </div>
          </div>
        </div>

        <div>
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Target type
          </div>
          <div className="d-flex">
            <div>
              {targetType == "CORE" ? (
                <CoreLogo />
              ) : targetType == "Json" ? (
                <FontAwesomeIcon
                  icon={faBracketsCurly}
                  color="#1C59A5"
                  style={{ fontSize: "18px" }}
                />
              ) : targetType == "File" ? (
                <FontAwesomeIcon
                  icon={faFileSpreadsheet}
                  color="#219653"
                  style={{ fontSize: "18px" }}
                />
              ) : (
                <></>
              )}
            </div>
            <div className="ml-2 mt-1" style={{ fontSize: "14px" }}>
              {targetType}
            </div>
          </div>
        </div>

        <div style={{ width: "20%" }}>
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Category
          </div>
          <div>
            {mapType == 2
              ? outputCategories[category ?? 0]
              : inputCategories[category ?? 0]}
          </div>
        </div>

        {/* <div>
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Level
          </div>
          <div>{level}</div>
        </div> */}

        {associatedPlans ? (
          <div style={{ width: "100px" }}>
            <div
              style={{ fontSize: "14px", color: "grey", whiteSpace: "nowrap" }}
              className="mb-1"
            >
              Associated Plans
            </div>
            {associatedPlans}
          </div>
        ) : (
          <div></div>
        )}
        {isActive ? (
          <div
            className="d-flex justify-content-center align-items-center border border-success rounded py-1 mr-26"
            style={{
              fontSize: "15px",
              height: "38px",
              width: "128px",
              textAlign: "center",
              alignSelf: "center",
              backgroundColor: "rgba(51, 170, 51, .3)",
              color: "green",
              marginLeft: "-80px",
            }}
          >
            Active
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center border border-danger rounded py-1 mr-26"
            style={{
              fontSize: "15px",
              height: "38px",
              width: "128px",
              textAlign: "center",
              alignSelf: "center",
              backgroundColor: "#f1697330",
              color: "red",
              marginLeft: "-80px",
            }}
          >
            InActive
          </div>
        )}
      </div>
    </Link>
  );
}

export default ProfilesTile;
